/* =====================================
	 7. CHART CONTAINER WRAPPER
	 ===================================== */
import React from "react";
import { useScaledConfig } from "../ChartScaleContext";
import { pxToRem } from "src/pages/Insights/transformer/dashboardUtils";
import { chartConfig } from "../chartConfig";
import { ChartRenderedFromType } from "src/pages/Insights/models/interfaces";

interface ChartContainerProps {
	children: React.ReactNode;
	className?: string;
	innerRef?: React.RefObject<HTMLDivElement>;
	renderedFrom?: ChartRenderedFromType;
}

export const ChartContainer: React.FC<ChartContainerProps> = ({ children, className = "", innerRef, renderedFrom }) => {
	const scaled = useScaledConfig();
	const basePadding = chartConfig.getMultiTileScalingConfig().base.layout.containerPadding;
	const isRenderedFromAskKural = [ChartRenderedFromType.AskKural, ChartRenderedFromType.AskKuralInline].includes(renderedFrom);

	// Convert to rem for CSS — the numeric comparison stays in px
	const paddingStyle = isRenderedFromAskKural ? {} : scaled.layout.containerPadding !== basePadding
		? { padding: pxToRem(scaled.layout.containerPadding) } // ← rem
		: {};

	return (
		<div
			ref={innerRef}
			className={`dashboard-chart-container bg-white w-full h-full flex flex-col font-sans ${isRenderedFromAskKural ? "" : "p-4"} ${className}`}
			style={paddingStyle}>
			{children}
		</div>
	);
};
